import { BaseModel, FeeType } from '../../global/models';
import { DocReference } from '../../global/models/doc-reference.models';
import { ProductRef } from '../product/product.models';
import { UserModelRef } from '../user';


export interface Piggy extends BaseModel {
  balance: number;
  currency: string;
  userId: string;
}

export interface PiggyTransaction extends BaseModel {
  amount: number,
  currency: string,  // siempre "EUR"
  prevBalance: number,  // balance anterior
  finalBalance: number, // balance luego de amount
  status: PiggyTransactionStatus,
  type: PiggyTransactionType,
  payload?: {
    bankAccount?: string, // only on PiggyTransactionType:bank
    taxId?: string, // only on PiggyTransactionType:bank
    bankRef?: string, // only on PiggyTransactionType:bank
    feeType?: FeeType, // only on PiggyTransactionType:fee
    feePct?: number, // only on PiggyTransactionType:fee
    description?: string, // maybe i'll add something here...
    feeIncludesTax?: boolean, // whether fee amount includes tax
    orderPriceNoTaxAmt?: number,  // Importe de la Orden (sin IVA) on Type:fee
    orderPriceNoTaxAmtBase?: number,  // Importe base Comisión (sin IVA) on Type:fee
    orderPriceTaxAmtBase?: number,  // Importe base Comisión (con IVA) on Type:fee
    limitedBase?: number,
    product?: ProductRef; // possible product, if fee is associated to one (creators/royalty, for example)
    originalFeeDate?: Date;
  },
  ref: DocReference, // documento causante de esta transacción
  user: UserModelRef,
}

export enum PiggyTransactionType {
  WALLET = 'wallet',
  BANK = 'bank',
  FEE = 'fee',
  ROLLBACK = 'rollback',
  EXPIRATION = 'expiration'
}

export enum PiggyTransactionStatus {
  PENDING = 'pending', // bank, fee
  COMPLETE = 'complete', // wallet, bank, fee (like withdrawn), rollback
  REJECTED = 'rejected', // bank
  EXPIRED = 'expired',
  ERROR = 'error', // not even used...
}

export enum PiggyTransactionOption { // why this? it's supposed to be FeeType
  SHARE = 'share',
  REFERRER = 'referrer',
  COUPON = 'coupon', // referrer coupon
  CREATOR = 'creator',
  ROYALTY = 'royalty',
  // this should not belong here:
  FIXED = 'fixed',
}

export interface CommissionsData {
  amount: number;
  ref: DocReference;
  date: Date;
  limitedBase: number;
  orderPriceNoTaxAmtBase: number;
  feeType: FeeType;
  description: string;
  type: PiggyTransactionType;
  status: PiggyTransactionStatus;
  feePct: number;
  product?: ProductRef;
  originalFeeDate?: Date;

}
